import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { UiModule } from '@freelancer/ui';
import { FreightlancerAboutPageTeamModalComponent } from './freightlancer-about-page-team-modal.component';

@NgModule({
  declarations: [FreightlancerAboutPageTeamModalComponent],
  exports: [FreightlancerAboutPageTeamModalComponent],
  imports: [CommonModule, UiModule, ComponentsModule],
})
export class FreightlancerAboutPageTeamModalModule {}
